import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indices',
  templateUrl: './indices.component.html',
  styleUrls: ['./indices.component.css']
})
export class IndicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
